const c = (n, t) => t.find((o) => o.name === n), d = (n, t) => t.find((o) => o.name === n), s = (n, t) => t.find(({ provider: o }) => o.name === n), f = (n, t) => {
  for (let o = 0; o < t.length; o++) {
    const r = t[o], { provider: e } = s(n.providerName, r.connectedProviders) || {};
    if (!e)
      continue;
    const i = d(n.integrationName, e.integrations);
    return i && c(n.actionName, i.actions) ? e : void 0;
  }
}, p = (n) => n ? ["account", "opportunity"].includes(n.record.type) : !1;
export {
  c as findAction,
  d as findIntegration,
  f as findLastUsedIntegrationProvider,
  s as findProvider,
  p as hasCardsForBinding
};
